import capitalize from 'capitalize';
import classNames from 'classnames';
import isUndefined from 'lodash.isundefined';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';

// components
import MemberInitialsWithCircle from '@atoms/MemberInitialsWithCircle';
import { BodyMedium, ButtonOutlineLarge, ButtonPrimaryLarge, DivWithShadowAlternate, H3 } from '@styled';

// functionality
import { mediaQueries } from '@general/breakpoints';
import { useScreenMinMd, useScreenSmDown } from '@hooks/useResponsive';
import { MembershipContext } from '../../../../context/MembershipProvider';

const MemberDetailsContainerStyled = styled.div`
    margin-left: 44px;
    margin-top: 0.5rem;

    @media ${mediaQueries.md} {
        display: flex;
        margin-left: 0;
    }
`;

const MembershipIsThisYou = () => {
    const { matchResultsByCompanyAndEmail, matchResultsRejected, setMatchResultsRejected } = useContext(
        MembershipContext
    );

    const isScreenMinMd = useScreenMinMd();
    const isScreenSmDown = useScreenSmDown();
    const [cannotProceed, setCannotProceed] = useState(false);

    const {
        first_name: firstName,
        last_name: lastName,
        city,
        state_province: stateProvince,
        phone_last_four: phoneLastFour,
        company,
        title,
    } = matchResultsByCompanyAndEmail;

    if (cannotProceed) {
        return (
            <div className="my-6">
                <h3>Contact Us</h3>
                <BodyMedium>
                    It looks like you need to update your email address before you can continue with your purchase.
                    Please email <a href="mailto:membership@icsc.com" className="display8 accent">membership@icsc.com</a>
                    {' '}to request an email update to your account.
                </BodyMedium>
            </div>
        );
    }

    return (
        <div>
            <H3>Is this you?</H3>
            <DivWithShadowAlternate
                className={classNames({ 'mt-2rem p-1.5rem': isScreenMinMd, 'mt-1.5rem p-1.25rem': isScreenSmDown })}
            >
                <div className="flex items-center">
                    <MemberInitialsWithCircle firstName={capitalize(firstName)} lastName={capitalize(lastName)} />

                    <div className="ml-0.75rem">
                        <BodyMedium className="text-admiral">
                            {capitalize(firstName)} {capitalize(lastName)}
                        </BodyMedium>
                    </div>
                </div>

                <MemberDetailsContainerStyled>
                    <div
                        className={classNames({
                            'pr-1rem w-1/2': isScreenMinMd,
                        })}
                    >
                        <div className={classNames({ 'ml-3.25rem': isScreenMinMd })}>
                            <BodyMedium>
                                {city}, {stateProvince}
                            </BodyMedium>
                            <BodyMedium>(•••) ••• - {phoneLastFour}</BodyMedium>
                        </div>
                    </div>

                    <div
                        className={classNames({
                            'w-1/2': isScreenMinMd,
                        })}
                    >
                        <BodyMedium>{company}</BodyMedium>
                        <BodyMedium>{title}</BodyMedium>
                    </div>
                </MemberDetailsContainerStyled>
            </DivWithShadowAlternate>

            {isUndefined(matchResultsRejected) && (
                <div className={classNames({ 'flex mt-2.5rem': isScreenMinMd, 'mt-1.5rem': isScreenSmDown })}>
                    <ButtonPrimaryLarge onClick={() => setCannotProceed(true)}>Yes, this is me</ButtonPrimaryLarge>
                    <ButtonOutlineLarge
                        className={classNames({ 'ml-1.25rem': isScreenMinMd, 'mt-0.75rem': isScreenSmDown })}
                        onClick={() => setMatchResultsRejected(true)}
                    >
                        No, that's not me
                    </ButtonOutlineLarge>
                </div>
            )}
        </div>
    );
};

MembershipIsThisYou.propTypes = {
    //
};

export default MembershipIsThisYou;
